<div class="box ml-2 mr-2" appRightClickBlock>
  <div class="box-body mt-3" >
    <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Position Column -->
      <ng-container matColumnDef="storeordc">
        <mat-header-cell *matHeaderCellDef>
          @if (userData && userData.roleId>3) {
            <label> {{'Store #' | translate}}</label>
          }
          @if (userData && userData.roleId<4) {
            <label> {{'DC Location' | translate }}</label>
          }

        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (userData && userData.roleId>3) {
            <a  [routerLink]="['/dcn-esign/order-summary/order-details',element.storeNumber]" >
              {{element.storeNumber }}
            </a>
          }
          @if (userData && userData.roleId<4) {
            <a [routerLink]="['/dcn-esign/order-summary/order-details',element.dcNumber]" >
              {{element.dcLocation }}
            </a>
          }
        </mat-cell>

      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="pending">
        <mat-header-cell *matHeaderCellDef> {{'Pending' | translate }} <mat-icon matTooltip="{{'PendingTooltip' | translate}} " [ngStyle]="{'color':'yellow'}">error</mat-icon>
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.pendingPoOrder }} </mat-cell>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="overdue">
      <mat-header-cell *matHeaderCellDef>{{'Overdue' | translate }}  <mat-icon matTooltip="{{'OverdueTooltip' | translate}} " [ngStyle]="{'color':'orange'}">error</mat-icon>
    </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.overDuePOOrder }} </mat-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="late">
    <mat-header-cell *matHeaderCellDef>{{'Late' | translate }}  <mat-icon matTooltip="{{'LateTooltip' | translate}} " [ngStyle]="{'color':'red'}">error</mat-icon>
  </mat-header-cell>
  <mat-cell *matCellDef="let element"> {{ element.latePoOrder }} </mat-cell>
</ng-container>
<ng-container matColumnDef="total">
  <mat-header-cell *matHeaderCellDef matTooltip="{{'TotalTooltip' | translate}} ">{{'Total' | translate }}  </mat-header-cell>
  <mat-cell *matCellDef="let element"> {{ element.totalPoOrders }} </mat-cell>
</ng-container>

<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<!-- <mat-paginator [length]="resultsLength" [pageSizeOptions]="[15, 30, 45]" [pageSize]="15" showFirstLastButtons>
</mat-paginator> -->

</div>
</div>